export default __webpack_public_path__ + "static/media/selectedTrackLogo.ee99d677.svg";